import React from "react";
import { useTranslation } from "react-i18next";
import {
  CONTRACT_LINK_CLASS_NAME,
  CONTRACT_TYPE,
} from "constants/moduleConstants/contract.constant";
import {
  POLICY_DOCUMENTS,
  POLICY_LINK_CLASS_NAME,
} from "constants/moduleConstants/policy.constant";

const PolicyLink = ({ href, className, children }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    className={className}
    onClick={(event) => event.stopPropagation()}
  >
    {children}
  </a>
);

const CoreContractPolicyLabel = ({ coreContracts = [] }) => {
  const { t } = useTranslation();

  const byType = coreContracts.reduce((acc, contract) => {
    acc[contract.type] = contract;
    return acc;
  }, {});

  const kvkk = byType[CONTRACT_TYPE.KVKK];
  const membership = byType[CONTRACT_TYPE.MEMBERSHIP];
  const cookie = byType[CONTRACT_TYPE.COOKIE];

  const kvkkLabel =
    kvkk?.description ||
    t(`auth.signUp.form.contracts.types.${CONTRACT_TYPE.KVKK}`);
  const membershipLabel =
    membership?.description ||
    t(`auth.signUp.form.contracts.types.${CONTRACT_TYPE.MEMBERSHIP}`);
  const cookieLabel =
    cookie?.description ||
    t(`auth.signUp.form.contracts.types.${CONTRACT_TYPE.COOKIE}`);

  const linkClassName = kvkk
    ? CONTRACT_LINK_CLASS_NAME
    : POLICY_LINK_CLASS_NAME;

  return (
    <p>
      <PolicyLink
        href={kvkk?.document || POLICY_DOCUMENTS.CONSENT}
        className={linkClassName}
      >
        {kvkkLabel}
      </PolicyLink>
      {t("auth.signUp.form.corePolicy.separator1")}
      <PolicyLink
        href={membership?.document || POLICY_DOCUMENTS.MEMBERSHIP}
        className={linkClassName}
      >
        {membershipLabel}
      </PolicyLink>
      {t("auth.signUp.form.corePolicy.separator2")}
      <PolicyLink
        href={cookie?.document || POLICY_DOCUMENTS.COOKIE}
        className={linkClassName}
      >
        {cookieLabel}
      </PolicyLink>{" "}
      {t("auth.signUp.form.corePolicy.suffix")}
    </p>
  );
};

export default CoreContractPolicyLabel;
